import { IntlWrapper, LoadingScreen } from './components';
import { createRoot } from 'react-dom/client';
import { StrictMode, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@kui-react/theme';

import './index.css';

const Home = lazy(() => import('./pages/Home'));
const OAuthCallback = lazy(() => import('./pages/OAuthCallback'));

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <IntlWrapper>
      <ThemeProvider theme='dark' withCanvas withReset>
        <BrowserRouter basename='/'>
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/oauth/callback' element={<OAuthCallback />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
    </IntlWrapper>
  </StrictMode>
);
